//
// user.js
// Use this to write your custom JS
//



const zindex_offcanvas = 1050;
let nav_topnav = document.getElementById( 'topnav' );
let offcanvas_navbar_lg = document.getElementById( 'navbar-lg' );
offcanvas_navbar_lg.addEventListener( 'show.bs.offcanvas', function () {
  nav_topnav.style.zIndex = zindex_offcanvas + 1;
});
offcanvas_navbar_lg.addEventListener( 'hidden.bs.offcanvas', function () {
  nav_topnav.style.zIndex = 'auto';
});




(function ($) {

  // 
  if( $( '.mw_wp_form' ).length ){
  
    $("label.form-check-label-catalog").each( function( index, element ){
      $(this).on("click", function(e) {
        var check_item =  $(this).prev().val();
        var item_text =  $(this).prev().val() + ' 1部';
        var article = $(".mw_wp_form textarea").val().replace(/\r\n|\r/g, "\n");
        var lines = article.split( '\n' );
        var outArray = new Array();
        if( $(this).prev().prop('checked') ){
          outArray.push( item_text );
        }
        for ( var i = 0; i < lines.length; i++ ) {
          if ( lines[i] == '' || lines[i] == "\n" || lines[i] == 'undefined' ) {
            delete lines[i];
            continue;
          } else {
            if( lines[i].indexOf( check_item ) !== -1 ){
              delete lines[i];
              continue;
            } else {
              outArray.push( lines[i] );
            }
          }
          console.log( lines[i] );
        }
        $(".mw_wp_form textarea").val(function( index, value ) {
          var content = "";
          for(var i = 0; i < outArray.length; i++){
            content = content + outArray[i] + "\n";
          }
          return content;
        });
        outArray = "";
      });
      
    });

  };


  // 
  // $('.is-style-container').wrapInner('<div class="container">');
  
})(jQuery);
